// extracted by mini-css-extract-plugin
export default {"gridContainer":"Videoplayer_gridContainer__d+qHS","gridItemContainer":"Videoplayer_gridItemContainer__adF8J","iframe":"Videoplayer_iframe__APHvo"};